import * as constants from "@/core/config/constant"

export const INPUT_METHOD_TEXT_SINGLE = 1
export const INPUT_METHOD_TEXT_MULTI = 2
export const INPUT_METHOD_SELECTION_SINGLE = 3
export const INPUT_METHOD_SELECTION_MULTI = 4
export const INPUT_METHOD_FILE = 5
export const INPUT_METHOD_LABEL = 6
export const INPUT_METHOD_DATE = 7
export const INPUT_METHOD_ATTACHMENT = 8
export const INPUT_METHOD_CALCULATION = 9
export const INPUT_METHOD_TABLE = 10

export const isShowSelections = (input)=>{
    return [INPUT_METHOD_SELECTION_SINGLE, INPUT_METHOD_SELECTION_MULTI].indexOf(parseInt(input.input_method)) > -1
}

export const isShowDisplayContent = (input) => {
    return [INPUT_METHOD_LABEL].indexOf(parseInt(input.input_method)) > -1
}

export const isShowAttachment = (input) => {
    return [INPUT_METHOD_ATTACHMENT].indexOf(parseInt(input.input_method)) > -1
}

export const isShowCalculation = (input) => {
    return [INPUT_METHOD_CALCULATION].indexOf(parseInt(input.input_method)) > -1
}

export const isInputTable = (input) => {
    if( input.input_method !== 10) 
        return false

    if( input.special_processing === 3 || input.display != true ){
        return false
    }

    return true
}

export const getSpecialProcessingOptions = (input) => {
    let options;
    switch (parseInt(input.input_method)) {
        case INPUT_METHOD_TEXT_SINGLE: 
        case 10: {
            options = constants.SPECIAL_PROCESSING
            break;
        }
        case 2: 
        case 3: 
        case 4: 
        case 5: 
        case 6: 
        case 7: 
        case 8: 
        case 9:
        default: {
            options = constants.SPECIAL_PROCESSING_CUSTOM
            break;
        }
    }
    
    return [ {
        label: 'なし',
        value: ' '
    },...options]
}
